import { useQuery } from "$hooks";
import { useHistory } from "react-router-dom";
import { GET_COMPANY_USER_BY_UUID_ADMIN } from "$queries";
import { RoutesBuilder } from "$models/RoutesBuilder";
import { ICompanyUser } from "$interfaces/CompanyUser";

export const useCompanyUserByUuidAdmin = (uuid: string) => {
  const history = useHistory();
  return useQuery<IVariables, IResponse>(GET_COMPANY_USER_BY_UUID_ADMIN, {
    variables: { uuid },
    errorHandlers: {
      UnauthorizedError: () => history.push(RoutesBuilder.public.forbidden()),
      CompanyUserNotFoundError: () => history.push(RoutesBuilder.public.notFound()),
      defaultHandler: () => history.push(RoutesBuilder.public.internalServerError())
    }
  })?.data?.getCompanyUserByUuidAdmin;
};

interface IVariables {
  uuid: string;
}

interface IResponse {
  getCompanyUserByUuidAdmin: ICompanyUser;
}
